import { type ReactElement } from 'react';
import { Alert } from '@citibox-panel/ui';
import { isMockMode } from '@/lib/apiClient';

// The panel mocks whenever `USE_MOCK_API` is not exactly `'false'` — a deliberate fail-safe, so that
// an environment which forgot the variable serves fixtures instead of making unintended production
// calls. Correct for READS. For a WRITE it is a trap: the request resolves, the in-memory store
// moves, and the batch card states a counter delta that never happened — on the one screen whose
// only receipt IS that delta, since the endpoint answers 200 with an empty body.
//
// Nothing else on screen distinguishes the two modes: the fixtures are a plausible mid-rollout pair
// on purpose. So this banner is the whole signal, and it is deliberately loud.
//
// Mounted ONCE in the authenticated layout rather than per screen: every surface that shows or
// writes real-looking data sits under it, and no slice has to learn what a mock is.
//
// TODO: i18n — copy en ES hasta Fase 1.
export function MockModeBanner(): ReactElement | null {
  if (!isMockMode) {
    return null;
  }

  return (
    <Alert severity="warning">
      Datos simulados: el panel no está conectado a app-service y nada de lo que se escriba se
      guarda.
    </Alert>
  );
}
